import { RootState } from "../../reducers";
import { useSelector } from "react-redux";
import BookmakerRow from "./BookmakerRow";
import { Container, Heading } from "./styles";
import { BookmakerDataType } from "../../types/bookmaker";
import { WarningMessage } from "../Results/styles";

interface Props {
  bookmakers?: BookmakerDataType[];
}

function BestOddsSelector({ bookmakers }: Props): JSX.Element {
  const filterStore = useSelector((state: RootState) => state.filter);

  return filterStore.isLicensed ? (
    <Container>
      <BookmakerRow oddsFilter="bestodds" />
      <BookmakerRow oddsFilter="bestline" />
      <Heading>
        <h4>Select Sportsbook</h4>
      </Heading>
      {bookmakers?.map((bookmaker) => (
        <BookmakerRow key={bookmaker.id} bookmaker={bookmaker} />
      ))}
    </Container>
  ) : (
    <WarningMessage>
      No Sportsbooks Available
    </WarningMessage>
  )
}

export default BestOddsSelector;
